import EventEmitter from 'eventemitter3';

/**
 * Global Application Event Bus (Event Emitter) which could be used to exchange data between different parts of app
 */
const appEventBus = new EventEmitter();
export default appEventBus;

if (process.env.NODE_ENV === 'development') {
  const originOnFn = appEventBus.on;
  const originEmitFn = appEventBus.emit;

  appEventBus.on = function decoratedOn(...args) {
    console.info(`appEventBus: listener has been added to "${args[0]}" event`); // eslint-disable-line

    return originOnFn.apply(this, args);
  };

  appEventBus.emit = function decoratedEmit(...args) {
    console.info(`appEventBus: "${args[0]}" event has been emitted with`, args[1]); // eslint-disable-line

    return originEmitFn.apply(this, args);
  };
}

// Registered app events;
export const API_ADD_ACTIVE_AD_GROUP_HEADER = 'osp:api:active-ad-group-header:add';
export const API_REMOVE_ACTIVE_AD_GROUP_HEADER = 'osp:api:active-ad-group-header:remove';
